<template lang="pug">
  .toolbar
    md-button.md-icon-button.toolbar-button(v-on:click="toggleSidebar"): md-icon menu
    h3.md-title.toolbar-title {{ $store.state.pageTitle }}
    .sep(style="flex: 1")
    .search-container(v-on:click="")
      component(v-if="(typeof $route.meta.toolbars) != 'undefined'" v-for="(toolbarName, index) in $route.meta.toolbars" v-bind:is="toolbars[$route.meta.module][toolbarName]" v-bind:key="index")
    .sep(style="flex: 1")
    .md-layout.md-alignment-center-right.user-menu.toolbar-user-menu(v-if="$store.state.users.current")
      md-menu(md-size="big" md-align-trigger)
        md-button(md-menu-trigger)
          md-avatar.md-avatar-icon.md-small
            md-icon person
          span {{ $store.state.users.current.login }}
        md-menu-content(md-theme="white")
          //router-link(v-bind:to="{ name: 'User', params: {user_id: $store.state.users.current.id}}" tag="md-menu-item"): span Профиль
          md-menu-item(v-on:click="toUser") Профиль
      md-button.md-icon-button.md-dense(v-on:click="logOut"): md-icon exit_to_app
</template>
<script>
  import moment from "moment"
  export default {
    name: 'toolbar',
    props: ['sidebar'],
    data() {
      return {}
    },
    created() {},
    watch: {},
    computed: {
      toolbars() {
        return this.$root.toolbars;
      },
      access() {
        return this.$store.state.module.accessModules;
      },
      user() {
        return this.$store.state.users.current;
      },
    },
    methods: {
      toggleSidebar() {
        this.$root.$emit('toggle-sidebar');
      },
      logOut() {
        this.$root.$emit('toggle-sidebar', false);
        this.$router.push({ name: 'Logout' });
      },
      toUser() {
        this.$root.$emit('show-dynamic-right-panel', 'User', {user_id: this.user.id});
      }
    }
  }
</script>
<style scoped lang="sass">
  .toolbar
    display: flex
    width: 100%
    align-items: center
    align-content: center
    .toolbar-button
    .toolbar-title
      flex-shrink: 0
    .toolbar-user-menu
      flex-shrink: 0
    .search-container
      position: relative
      display: flex
      transition: all .2s
      border: 0
      outline: none
      width: 100% !important
      align-items: center
      flex: 1 1 auto
      max-width: 1184px
      box-sizing: border-box
      margin: 0 24px
    .search-container.active
      #search
        background: white
  #main-toolbar
    will-change: opacity,background-color,box-shadow,color,min-height !important
</style>



// WEBPACK FOOTER //
// Toolbar.vue?60c33618